require('normalize.css/normalize.css');
require('./main.scss'); 
require('./tierfotos.xml');
/* die Bilder müssen für Webpack auf den Server in Localhost geladen werden */
require('./images/tier2.jpg');
require('./images/tier3.jpg');
require('./images/tier4.jpg');
require('./images/tier5.jpg');
require('./images/tier6.jpg');
require('./images/tier7.jpg');
require('./images/tier8.jpg');
import css from './xml.scss'; 